import { rest } from 'msw'

import { AdminCardApiModelStub } from '@webapp/modules/spending-cards/data-access/api-models/stubs/AdminCardApiModel.stub'
import { getResponseObject } from '@webapp/tests'

export const mockGetAdminCardSuccess = (
  externalId: string,
  cardStub = AdminCardApiModelStub.build()
) => {
  return rest.get(`/api/v3/pay/admin/cards/${externalId}/`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(cardStub)))
  })
}

export const mockGetAdminCardError = (externalId: string) => {
  return rest.get(`/api/v3/pay/admin/cards/${externalId}/`, (_, res, ctx) => {
    return res.once(ctx.status(400))
  })
}
